import { encryptToken } from "./SecureToken";


//function to set encrypted token in localStorage 
export const setToken = (token) => {
  const encryptedToken = encryptToken(token);
  localStorage.setItem('authToken', encryptedToken);
};

//function to get token from localStorage 
export const getToken = () => {
  return localStorage.getItem('authToken');
};

//function to clear token from localStorage
export const clearToken = () => {
  localStorage.removeItem('authToken');
};

//Set role type in localStorage
export const setRoleType = (roleType) => {
  localStorage.setItem('roleType', roleType);
};


//Get Role Type
export const getRoleType = () => {
  return localStorage.getItem('roleType');
};


//Clear Role type
export const clearRoleTypeLocal = () => {
  localStorage.removeItem('roleType');
};
